import { getWindow } from "@faire/web/common/globals/getWindow";
import { isFastly } from "@faire/web/common/images/optimizeImages";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";

// Helper function for checking if an image url (i.e. external url)
// is accessible and returns a valid response, and not 4xx/5xx.

const checkValidImage = async (image: IImage): Promise<IImage | undefined> => {
  return new Promise<IImage | undefined>((resolve, reject) => {
    const imageUrl = image.url;
    const ImgConstructor = getWindow()?.Image;
    if (!imageUrl) {
      reject(undefined);
    } else if (isFastly(imageUrl) || ImgConstructor === undefined) {
      // if internal url, assume link is safe OR if in a non-browser environment
      resolve(image);
    } else {
      const img = new ImgConstructor();
      img.src = imageUrl;
      img.onload = () => resolve(image);
      img.onerror = () => {
        reject(undefined);
      };
    }
  }).catch(() => undefined);
};

export const filterInvalidImages = async (
  images: IImage[]
): Promise<IImage[]> => {
  const result = await Promise.all(
    images.map((image) => checkValidImage(image))
  );
  return result.filter(isNotUndefined);
};
